import React from 'react';


export const BotonPrincipal = ({ texto, onClick }) => {
  return (
    <button
    style={{
      padding: "6px 10px",
      fontSize: "16px",
      border: "none",
      borderRadius: "5px",
      backgroundColor: "#BA1721",  
      color: "white",  
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      height:"auto"
    }}
    onMouseOver={(e) => e.target.style.backgroundColor = "#A8161F"}  
    onMouseOut={(e) => e.target.style.backgroundColor = "#BA1721"}
    onClick={(e) => onClick(e)}
  >
    {texto}  
  </button>
  );
};


